document.addEventListener("mousemove", parallax);
function parallax(e){
  
  let width = document.getElementById('MainContent').clientWidth
  if (width < 768){
    return
  }
    document.querySelectorAll(".bg-objects").forEach(function(move){
        var moving_value = move.getAttribute("data-value");
        var x = (e.clientX * moving_value) / 250;
        var y = (e.clientY * moving_value) / 250;

        move.style.transform = "translateX("+ x +"px) translateY("+ y +"px)"; 
    })

}